import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ObserverService } from './observer.service';
import { StorageService } from './storage.service';

@Injectable()
export class CourierService {

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private databaseService: DatabaseService,
        private storageService: StorageService
    ) { }

    bulkAddCouriers(raw_couriers) {
        return new Promise<void>((resolve, reject) => {
            if (raw_couriers !== undefined) {
                this.databaseService.courier.clear().then(async () => {
                    let couriers = [];
                    for (let i = 0; i < raw_couriers.length; i++) {
                        let courier = {};
                        courier["id"] = raw_couriers[i].id;
                        courier["title"] = raw_couriers[i].title;
                        if(raw_couriers[i].tracking_url) {
                            courier["tracking_url"] = raw_couriers[i].tracking_url;
                        }
                        if(raw_couriers[i].country) {
                            courier["country_id"] = raw_couriers[i].country.id;
                        }
                        couriers.push(courier);
                    }
                    await this.databaseService.courier.bulkAdd(couriers).then(() => {
                        this.observerService.publish("couriers_changed", null);
                        this.storageService.set("couriers_last_updated_date", new Date().toISOString()).then(() => { }).catch(() => { });
                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject();
                    });
                })
                .catch((error) => {
                    console.error(error);
                    reject();
                });
            }
            else {
                resolve();
            }
        });
    }

    getCouriers() {
        return new Promise((resolve, reject) => {
            this.databaseService.courier.toArray().then((couriers) => {
                resolve(couriers);
            })
            .catch((error) => {
                console.error(error);
                reject();
            });
        });
    } 

    getCourier(courier_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.courier.get(courier_id).then((courier) => {
                resolve(courier);
            })
            .catch(() => {
                reject();
            });
        });
    }

}
